import { render, staticRenderFns } from "./GChatMessage.vue?vue&type=template&id=1c97b4d3&scoped=true&"
import script from "./GChatMessage.vue?vue&type=script&lang=ts&"
export * from "./GChatMessage.vue?vue&type=script&lang=ts&"
import style0 from "./GChatMessage.vue?vue&type=style&index=0&id=1c97b4d3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c97b4d3",
  null
  
)

export default component.exports